const categories = {
  INTERNAL: 'Internal',
  EXTERNAL: 'External'
}

export default categories
